import { Alert, Button } from "@mui/material";
import { useAsyncAction } from "nate-react-api-helpers";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api/API";
import { useUrlState } from "../../misc/urlParams";
import { AccountCard } from "./AccountCard";

// ConfirmPage is where the confirm email links to. The account is logged in and sent
// to its workspace.
export function ConfirmPage() {
    const url = useUrlState();
    const token = url.text("token");
    const invite = url.text("invite");

    const confirm = useAsyncAction(async (input: { token: string; inviteToken?: string }) => {
        const result = await api.account.confirm(input);

        // full page load so every provider starts over with the new session
        window.location.href = "/w/" + result.workspace + "/tasks";
        return result;
    }, []);

    // the token works once, so the call goes out once
    const sent = useRef(false);
    const callback = confirm.callback;
    useEffect(() => {
        if (sent.current) return;

        sent.current = true;
        callback({ token: token, inviteToken: invite || undefined });
    }, [callback, token, invite]);

    return (
        <AccountCard title="Confirm your email">
            {confirm.LoadingElement}
            {confirm.error && (
                <Button component={Link} to="/login" fullWidth sx={{ mt: 2 }}>Go to login</Button>
            )}
            {confirm.result && <Alert severity="success">Your email is confirmed.</Alert>}
        </AccountCard>
    );
}
